/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import MuiIconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';

function Button({ className, ...props }) {
  return (
    <MuiIconButton
      className={clsx({
        [className]: true,
      })}
      {...props}
    />
  );
}

Button.defaultProps = {
  color: 'primary',
  variant: 'contained',
  disabled: false,
};

export default Button;
